<template>
  <div>
    <!-- Modal del formulario -->
    <div :class="{'modal': true, 'is-active': !showResult}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box" style="max-width: 450px; margin: auto;">

          <div class="field">
            <label class="label">Comprobante de pago</label>
            <div class="file has-name is-right is-medium">
              <label class="file-label" style="width: 100%;">
                <input class="file-input" type="file" name="resume" @change="handleFileUpload" />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">
                    <span class="material-icons">upload</span>
                  </span>
                </span>
                <span class="file-name" style="width: 100%;">{{ file ? file.name : 'No file selected' }}</span>
              </label>
            </div>
          </div>

          <div v-if="hasDeduction" class="breakdown">
            <p class="breakdown-title">Enganche {{ partnerName }}</p>
            <div class="breakdown-row">
              <span>Valor del equipo</span>
              <strong>${{ formatMoney(effectiveDeviceValue) }}</strong>
            </div>
            <div class="breakdown-row">
              <span>Enganche cubierto{{ isFixedAmount ? '' : ` (${deduction.percentage}%)` }}</span>
              <strong class="has-text-danger">- ${{ formatMoney(coveredAmount) }}</strong>
            </div>
            <div class="breakdown-row is-total">
              <span>Saldo a acreditar</span>
              <strong>${{ formatMoney(creditedAmount) }}</strong>
            </div>
            <p class="breakdown-note">Este es el monto que hay que depositarle al usuario.</p>
          </div>

          <div class="field">
            <label class="checkbox">
              <input type="checkbox" v-model="precioDiferente" />
              Precio final diferente
            </label>
          </div>

          <div v-if="precioDiferente">
            <div class="field">
              <label class="label">Precio final</label>
              <div class="control">
                <input class="input" type="number" min="0" v-model="precioFinal" placeholder="Ingresa el precio final" />
              </div>
              <p v-if="hasDeduction" class="help">
                {{ isFixedAmount
                  ? `Es el valor del equipo, no el depósito: el enganche de $${deduction.coveredAmountLabel} se descuenta de este monto.`
                  : `Es el valor del equipo, no el depósito: el enganche del ${deduction.percentage}% se recalcula sobre este monto.` }}
              </p>
            </div>

            <div class="field">
              <label class="label">Descripción</label>
              <div class="control">
                <input class="input" type="textarea" v-model="descripcion" placeholder="Descripción del cambio de precio" />
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <button class="button is-danger is-outlined is-fullwidth is-rounded is-medium" @click="close">Cerrar</button>
            </div>
            <div class="column">
              <button class="button is-danger is-fullwidth is-rounded is-medium" :class="{ 'is-loading': loadingStatus }" @click="submit">Aceptar</button>
            </div>
          </div>

          <div v-if="error" class="notification is-danger">
            <p>{{ error }}</p>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>

    <!-- Modal del resultado -->
    <div :class="{'modal': true, 'is-active': showResult}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box" style="max-width: 350px; margin: auto;">
          <div class="field">
            <div class="control">
              <p>{{ apiResult }}</p>
            </div>
          </div>
          <div class="field is-grouped is-grouped-right">
            <div class="control">
              <button class="button is-danger is-outlined is-rounded is-medium" @click="close">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      default: () => {}
    },
    action: {
      type: Function,
      default: () => {}
    },
    partnerName: {
      type: String,
      default: ''
    },
    deduction: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasDeduction () {
      return !!(this.deduction && this.deduction.hasDeduction)
    },
    isFixedAmount () {
      return this.hasDeduction && this.deduction.source === 'amount'
    },
    effectiveDeviceValue () {
      if (!this.hasDeduction) return 0
      const override = Number(this.precioFinal)
      return this.precioDiferente && Number.isFinite(override) && override > 0
        ? Math.round(override)
        : this.deduction.deviceValue
    },
    coveredAmount () {
      if (!this.hasDeduction) return 0
      return this.isFixedAmount
        ? this.deduction.coveredAmount
        : Math.round(this.effectiveDeviceValue * (this.deduction.percentage / 100))
    },
    creditedAmount () {
      return Math.max(this.effectiveDeviceValue - this.coveredAmount, 0)
    }
  },
  data () {
    return {
      file: null,
      loadingStatus: false,
      apiResult: null,
      error: null,
      showResult: false,
      precioDiferente: false,
      precioFinal: null,
      descripcion: ''
    }
  },
  methods: {
    formatMoney (amount) {
      return Number(amount || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })
    },
    handleFileUpload (event) {
      this.file = event.target.files[0]
    },
    async submit () {
      if (!this.file) {
        this.error = 'Por favor, selecciona un archivo.'
        return
      }

      try {
        this.loadingStatus = true
        const formData = new FormData()
        formData.append('file', this.file)

        if (this.precioDiferente) {
          formData.append('precioFinal', this.precioFinal)
          formData.append('descripcion', this.descripcion)
        }

        const response = await this.action(formData)

        this.apiResult = response
        this.error = null
        this.showResult = true
      } catch (err) {
        this.error = 'Error al realizar la operación. Por favor, inténtalo de nuevo.'
        this.apiResult = null
      } finally {
        this.loadingStatus = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.breakdown {
  background-color: #fafafa;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}
.breakdown-title {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9a9a9a;
  margin-bottom: 0.6rem;
}
.breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.35rem 0;
}
.breakdown-row.is-total {
  border-top: 1px solid #e4e4e4;
  margin-top: 0.35rem;
  padding-top: 0.6rem;
  font-size: 1.05rem;
}
.breakdown-note {
  font-size: 0.75rem;
  color: #7a7a7a;
  margin-top: 0.5rem;
}
.box {
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
.field {
  margin-bottom: 1rem;
}
.button.is-fullwidth {
  width: 100%;
}
.modal-background {
  background-color: rgba(0, 0, 0, 0.5);
}
.is-danger{
  background-color: #EB5965;
}
</style>
